import { Box, Card, CardContent, Typography } from "@mui/material";
import { FC } from "react";
import { figureFormatter } from "../../../utils/figure_formatter";
import { getName } from "../../Clients/models/ColumnShape";
import StatusBtn from "../../../components/UI/StatusBtn";
import { useNavigate } from "react-router-dom";
import { Span } from "../../../components/Typography";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";

interface IDetailsInfo {
  entityDetails: any;
  extraData?: any;
}

const LoanTopup: FC<IDetailsInfo> = ({ entityDetails, extraData }) => {
  const navigate = useNavigate();

  return (
    <Card>
      <CardContent>
        <Typography
          sx={{
            fontSize: 14,
            mb: 1.5,
            fontWeight: "bold",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          gutterBottom
        >
          Loan Details
          <Box
            sx={{ display: "inline-block" }}
            onClick={() => {
              navigate(`/loans/loan-details/${entityDetails?.id}`);
            }}
          >
            <StatusBtn
              type={1}
              title={
                <Span display={"inline-flex"} padding={0.5} gap={1}>
                  More <ArrowOutwardIcon fontSize={"small"} color="primary" />
                </Span>
              }
            />
          </Box>
        </Typography>

        <Typography
          sx={{ fontSize: 14, mb: 1.5 }}
          color="text.disabled"
          gutterBottom
        >
          Loan No:
        </Typography>
        <Typography sx={{ fontSize: 14, mb: 1.5 }} gutterBottom>
          {entityDetails?.loan_no}
        </Typography>

        <Typography
          sx={{ fontSize: 14, mb: 1.5 }}
          color="text.disabled"
          gutterBottom
        >
          Branch:
        </Typography>
        <Typography sx={{ fontSize: 14, mb: 1.5 }} gutterBottom>
          {entityDetails?.branch?.name}
        </Typography>

        <Typography
          sx={{ fontSize: 14, mb: 1.5 }}
          color="text.disabled"
          gutterBottom
        >
          Client:
        </Typography>
        <Typography sx={{ fontSize: 14, mb: 1.5 }} gutterBottom>
          {getName(
            entityDetails?.account_details?.client_details?.user_details,
            entityDetails?.account_details?.client_details?.client_type,
          )}
        </Typography>

        <Typography
          sx={{ fontSize: 14, mb: 1.5 }}
          color="text.disabled"
          gutterBottom
        >
          Principal:
        </Typography>
        <Typography sx={{ fontSize: 14, mb: 1.5 }} gutterBottom>
          {figureFormatter({
            figure: entityDetails?.principal,
            currency: entityDetails?.currency?.currency || "",
          })}
        </Typography>

        <Typography
          sx={{ fontSize: 14, mb: 1.5 }}
          color="text.disabled"
          gutterBottom
        >
          Total Paid:
        </Typography>
        <Typography sx={{ fontSize: 14, mb: 1.5 }} gutterBottom>
          {figureFormatter({
            figure: entityDetails?.amount_paid,
            currency: entityDetails?.currency?.currency || "",
          })}
        </Typography>

        <Typography
          sx={{ fontSize: 14, mb: 1.5 }}
          color="text.disabled"
          gutterBottom
        >
          Outstanding Balance:
        </Typography>
        <Typography sx={{ fontSize: 14, mb: 1.5 }} gutterBottom>
          {figureFormatter({
            figure: entityDetails?.current_balance,
            currency: entityDetails?.currency?.currency || "",
          })}
        </Typography>

        <Typography
          sx={{ fontSize: 14, mb: 1.5 }}
          color="text.disabled"
          gutterBottom
        >
          Requested Topup Amount:
        </Typography>
        <Typography sx={{ fontSize: 14, mb: 1.5 }} gutterBottom>
          {figureFormatter({
            figure: extraData?.amount,
            currency: entityDetails?.currency?.currency || "",
          })}
        </Typography>

        <Typography
          sx={{ fontSize: 14, mb: 1.5 }}
          color="text.disabled"
          gutterBottom
        >
          Topup Request Comment:
        </Typography>
        <Typography sx={{ fontSize: 14, mb: 1.5 }} gutterBottom>
          {extraData?.comment}
        </Typography>

        <Typography
          sx={{ fontSize: 14, mb: 1.5 }}
          color="text.disabled"
          gutterBottom
        >
          Topup Request Date:
        </Typography>
        <Typography sx={{ fontSize: 14, mb: 1.5 }} gutterBottom>
          {extraData?.application_date}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default LoanTopup;
